import { Button, Sheet } from "@mui/joy";
import styled from "styled-components";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { BiMailSend } from "react-icons/bi";
import MovingText from "react-moving-text";
import { useState } from "react";
import { Squash as Hamburger } from "hamburger-react";

const NavBarItems = styled.div`
  display: flex;
  width: ${(props) => (props.size.width >= 800 ? "50%" : "100%")};
  justify-content: space-between;
  margin-right: 5%;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-weight: 400;
`;

const SocialButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 10%;
  margin-right: auto;
`;

const SocialButtonsMobile = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  width: max-content;
`;

const NavBarItem = styled.a`
  display: flex;
  line-height: 2.7em;
  font-weight: 700;
  font-size: large;
  text-decoration: none;
  color: inherit;
  background: linear-gradient(
      to right,
      rgba(100, 200, 200, 0),
      rgba(100, 200, 200, 0)
    ),
    linear-gradient(
      to right,
      rgba(204, 0, 0, 1),
      rgba(204, 0, 0, 1),
      rgba(204, 0, 0, 1)
    );
  background-size: 100% 3px, 0 3px;
  background-position: 100% 100%, 0 100%;
  background-repeat: no-repeat;
  transition: background-size 400ms;
  &:hover {
    background-size: 0 3px, 100% 3px;
  }
`;

const NavBarShadow = styled.div`
  width: max-content;
  margin: auto;
  border-radius: 15px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
`

const Navbar = (props) => {
  const SocialButton = (info) => {
    return (
      <Button
        sx={{
          display: "flex",
          fontSize: "x-large",
        }}
        size="lg"
        variant="plain"
        onClick={(e) => {
          e.preventDefault();
          window.open(info.link, info.link);
        }}
      >
        {info.icon_type}
      </Button>
    );
  };

  const DarkModeToggle = props.darkModeToggle;

  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleStyle = {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: "x-large",
  };

  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const navbarStyle = {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomLeftRadius: drawerVisible ? 0 : 15,
    borderBottomRightRadius: drawerVisible ? 0 : 15,
    padding: "1em",
    margin: "auto",
    marginTop: 2,
    display: "flex",
    width: dynamicWidth(),
  };

  const mobileNavbarContainer = {
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    padding: "1em",
    margin: "auto",
    display: "flex",
    width: dynamicWidth()
  };

  // Desktop Rendering
  if (dynamicWidth() >= 600) {
    return (
      <NavBarShadow>
        <Sheet sx={navbarStyle}>
          <SocialButtons>
            <SocialButton
              icon_type={<BsLinkedin />}
              link={props.social[0].linkedin}
            />
            <SocialButton
              icon_type={<BsGithub />}
              link={props.social[1].github}
            />
            <SocialButton
              icon_type={<BiMailSend />}
              link={props.social[2].mail}
            />
          </SocialButtons>
          <NavBarItems size={props.size}>
            <MovingText
              type="blur"
              duration="800ms"
              delay="0s"
              direction="reverse"
              timing="ease-in"
              iteration="1"
              fillMode="forwards"
            >
              <NavBarItem href="#experience">Experience</NavBarItem>
            </MovingText>
            <MovingText
              type="blur"
              duration="800ms"
              delay="0s"
              direction="reverse"
              timing="ease-in"
              iteration="1"
              fillMode="forwards"
            >
              <NavBarItem href="#projects">Projects</NavBarItem>
            </MovingText>
            <MovingText
              type="blur"
              duration="800ms"
              delay="0s"
              direction="reverse"
              timing="ease-in"
              iteration="1"
              fillMode="forwards"
            >
              <NavBarItem href={props.resume_link} download>
                Resume
              </NavBarItem>
            </MovingText>
          </NavBarItems>
          <DarkModeToggle sx={{ toggleStyle }} />
        </Sheet>
      </NavBarShadow>
    );
  }
  // Mobile Rendering
  else {
    return (
      <NavBarShadow id="navbar">
        <Sheet sx={navbarStyle}>
          <Button
            variant="outlined"
            onClick={() => setDrawerVisible(!drawerVisible)}
          >
            <Hamburger toggled={drawerVisible} toggle={drawerVisible} size={20} duration={0.75} rounded/>
          </Button>
          <SocialButtonsMobile>
            <SocialButton
              icon_type={<BsLinkedin />}
              link={props.social[0].linkedin}
            />
            <SocialButton
              icon_type={<BsGithub />}
              link={props.social[1].github}
            />
            <SocialButton
              icon_type={<BiMailSend />}
              link={props.social[2].mail}
            />
            <DarkModeToggle sx={{ toggleStyle }} />
          </SocialButtonsMobile>
        </Sheet>
          <Sheet
            sx={{
              ...mobileNavbarContainer,
              opacity: !drawerVisible ? "0" : "1",
              visibility: !drawerVisible ? "hidden" : "visible",
              position: !drawerVisible ? "absolute" : "static",
            }}
          >
            <NavBarItems size={props.size}>
              <MovingText
                type="blur"
                duration="800ms"
                delay="0s"
                direction="reverse"
                timing="ease-in"
                iteration="1"
                fillMode="forwards"
              >
                <NavBarItem href="#experience">Experience</NavBarItem>
              </MovingText>
              <MovingText
                type="blur"
                duration="800ms"
                delay="0s"
                direction="reverse"
                timing="ease-in"
                iteration="1"
                fillMode="forwards"
              >
                <NavBarItem href="#projects">Projects</NavBarItem>
              </MovingText>
              <MovingText
                type="blur"
                duration="800ms"
                delay="0s"
                direction="reverse"
                timing="ease-in"
                iteration="1"
                fillMode="forwards"
              >
                <NavBarItem href={props.resume_link} download>
                  Resume
                </NavBarItem>
              </MovingText>
            </NavBarItems>
          </Sheet>
      </NavBarShadow>
    );
  }
};

export default Navbar;
